<template>
<div class="row">
    <div class="col-lg-6">
        <h3 class="font-weight-light">Detalle de membresía</h3>
        <table class="table table-striped">
            <tbody>
                <tr>
                    <td>Plan</td>
                    <td>{{planUser.plan.plan}} / {{planUser.plan.name}}</td>
                </tr>
                <tr>
                    <td>Candidatos</td>
                    <td>{{planUser.candidates}}</td>
                </tr>
                <tr>
                    <td>Candidatos Utilizados</td>
                    <td>{{planUser.candidates_use}}</td>
                </tr>
                <tr>
                    <td>Fecha de expiración</td>
                    <td>{{planUser.expired_at | timeDate}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-lg-6">
        <h3 class="font-weight-light">Opciones</h3>
        <p>
            Actualmente cuentas con esta membresía {{planUser.plan.plan}}, por lo que no es posible cargarla nuevamente a tu cuenta.<br>
        </p>
        <p>
            <b>¿Te quedaste sin candidatos?</b>
            No te preocupes, Kllaar.com tiene la opción de cargar para ver la información de este contacto, 
            es necesario adquirir más candidatos.
        </p>
        <router-link to="/memberships?addcandidates=true" class="btn b-orange shadow-sm">
            <i class="fas fa-user-friends"></i>
            Añadir más candidatos
        </router-link>
    </div>
</div>
</template>
<script>
export default {
    props: {
        planUser: Object
    },
    data() {
        return {
            
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/#public/member/components/isNowPlan.vue